import { useState } from 'react';
import { useRouter } from 'src/routes/hooks';

import { LoadingButton } from '@mui/lab';
import {
  Box,
  Card,
  Stack,
  Avatar,
  Button,
  TextField,
  Typography,
  CardContent,
  Switch,
  FormControlLabel,
} from '@mui/material';

import { _myAccount } from 'src/_mock';
import { API_ENDPOINTS } from 'src/config/api.config';

export function ProfileView() {
  const router = useRouter();
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({
    name: _myAccount.data.displayName,
    username: _myAccount.data.email,
    accountNonExpired: true,
    accountNonLocked: true,
    credentialsNonExpired: true,
    enabled: true,
  });

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    try {
      const response = await fetch(`${API_ENDPOINTS.USERS}/${formData.username}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setIsEditing(false);
        // Başarılı güncelleme mesajı gösterilebilir
      }
    } catch (error) {
      console.error('Profil güncellenirken hata:', error);
    }
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" sx={{ mb: 5 }}>
        Profil
      </Typography>

      <Card>
        <CardContent>
          <Box
            component="form"
            onSubmit={handleSubmit}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 3,
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Avatar
                src={_myAccount.data.photoURL}
                alt={formData.name}
                sx={{ width: 80, height: 80 }}
              />
              <Box>
                <Typography variant="h6">
                  {formData.name}
                </Typography>
                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                  {formData.username}
                </Typography>
              </Box>
            </Box>

            <Stack spacing={3} sx={{ mt: 3 }}>
              <TextField
                fullWidth
                label="İsim"
                value={formData.name}
                disabled={!isEditing}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              />

              <TextField
                fullWidth
                label="Email"
                value={formData.username}
                disabled
              />

              {isEditing && (
                <Stack spacing={2}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={formData.accountNonExpired}
                        onChange={(e) => setFormData({ ...formData, accountNonExpired: e.target.checked })}
                        disabled={!isEditing}
                      />
                    }
                    label="Hesap Süresi Aktif"
                  />

                  <FormControlLabel
                    control={
                      <Switch
                        checked={formData.accountNonLocked}
                        onChange={(e) => setFormData({ ...formData, accountNonLocked: e.target.checked })}
                        disabled={!isEditing}
                      />
                    }
                    label="Hesap Kilitli Değil"
                  />

                  <FormControlLabel
                    control={
                      <Switch
                        checked={formData.credentialsNonExpired}
                        onChange={(e) => setFormData({ ...formData, credentialsNonExpired: e.target.checked })}
                        disabled={!isEditing}
                      />
                    }
                    label="Kimlik Bilgileri Aktif"
                  />

                  <FormControlLabel
                    control={
                      <Switch
                        checked={formData.enabled}
                        onChange={(e) => setFormData({ ...formData, enabled: e.target.checked })}
                        disabled={!isEditing}
                      />
                    }
                    label="Hesap Aktif"
                  />
                </Stack>
              )}
            </Stack>

            <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
              {isEditing ? (
                <>
                  <Button variant="outlined" onClick={() => router.back()}>
                    İptal
                  </Button>
                  <LoadingButton type="submit" variant="contained">
                    Kaydet
                  </LoadingButton>
                </>
              ) : (
                <Button variant="contained" onClick={() => setIsEditing(true)}>
                  Düzenle
                </Button>
              )}
            </Box>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
} 